import Vue from 'vue'
import Router from 'vue-router'
import Homeone from '@/demo_page/home_one'
import Navbar from '@/components/navbar'
import About from '@/components/about'
import Feature from '@/components/feature'
import Screenshots from '@/components/screenshots'
import Team from '@/components/team'
import LatestBlog from '@/components/latest_blog'
import Price from '@/components/price'
import Testimonial from '@/components/testimonial'
import ContactUs from '@/components/contact_us'
import Subscribe from '@/components/subscribe'
import Map from '@/components/map'
import Tile from '@/components/tile'
import Footer from '@/components/footer'
import PageNotFound from '@/components/pagenotfound'
import js from '@/components/js'
import Bloglist from '@/blog/blog_list'
import BlogDetails from '@/blog/blog_details'
import BlogLeftSide from '@/blog/blog_leftside'
import BlogRightSide from '@/blog/blog_rightside'
import BlogLeftSidebar from '@/blog/blog_left_sidebar'
import BlogRightSidebar from '@/blog/blog_right_sidebar'
import Signin from '@/pages/sign_in'
import Signup from '@/pages/sign_up'
import ForgetPassword from '@/pages/forget_password'
import Review from '@/pages/review'
import Thankyou from '@/pages/thank_you'
import Faq from '@/pages/faq'
import download from '@/pages/download'
import comingsoon from '@/pages/coming_soon'
import Emailtemplate from '@/pages/email_template'
import color from '@/components/color'
import PrivacyPage from '@/pages/privacy_page'
import TermsAndConditions from '@/pages/terms_and_conditions'
import HowToVideo from '@/pages/how_to_video'

// disabled imports.
// import Hometwo from '@/demo_page/home_two'
// import Homethree from '@/demo_page/home_three'
// import Main from '@/demo_page/main'
// import NavbarBlog from '../components/navbar_blog'

Vue.use(Router)
Vue.component('Navbar', Navbar)
Vue.component('About', About)
Vue.component('Feature', Feature)
Vue.component('Screenshots', Screenshots)
Vue.component('Team', Team)
Vue.component('Latest-blog', LatestBlog)
Vue.component('Price', Price)
Vue.component('Testimonial', Testimonial)
Vue.component('Contact_us', ContactUs)
Vue.component('Subscribe', Subscribe)
Vue.component('Map', Map)
Vue.component('Footer', Footer)
Vue.component('BlogList', Bloglist)
Vue.component('BlogDetails', BlogDetails)
Vue.component('BlogLeftSide', BlogLeftSide)
Vue.component('BlogRightSide', BlogRightSide)
Vue.component('BlogLeftSidebar', BlogLeftSidebar)
Vue.component('BlogRightSidebar', BlogRightSidebar)
Vue.component('Signin', Signin)
Vue.component('Signup', Signup)
Vue.component('ForgetPassword', ForgetPassword)
Vue.component('Thankyou', Thankyou)
Vue.component('Review', Review)
Vue.component('Faq', Faq)
Vue.component('download', download)
Vue.component('comingsoon', comingsoon)
Vue.component('Emailtemplate', Emailtemplate)
Vue.component('js', js)
Vue.component('Tile', Tile)
Vue.component('color', color)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {path: '/', redirect: '/home'},
    {
      path: '/privacy',
      name: 'privacy_page',
      component: PrivacyPage
    },
    {
      path: '/terms-and-conditions',
      name: 'terms_and_conditions',
      component: TermsAndConditions
    },
    {
      path: '/how-to-video',
      name: 'how_to_video',
      component: HowToVideo
    },
    {
      path: '/home',
      name: 'home_one',
      components:
      {
        default: Homeone,
        navbar: Navbar
      }
    },
    {
      path: '/coming-soon',
      name: 'coming_soon',
      component: comingsoon
    },
    {
      path: '/404',
      name: 'page_not_found',
      component: PageNotFound
    },
    {
      path: '*',
      redirect: '/404'
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js